import type { SupplyConfidence } from '@/api/client'

/**
 * How the supply model's confidence reads, on the supplies page and in the
 * property calendar's supply sheet. Labels only: the confidence itself is
 * admin-api's.
 */
export const CONFIDENCE_TONES: Record<
  SupplyConfidence,
  'secondary' | 'warning' | 'success' | 'default'
> = {
  none: 'secondary',
  low: 'warning',
  medium: 'default',
  high: 'success',
}

export const CONFIDENCE_LABELS: Record<SupplyConfidence, string> = {
  none: 'No rate yet',
  low: 'Low confidence',
  medium: 'Medium confidence',
  high: 'High confidence',
}
